import { Center, Box, HStack, VStack } from 'native-base';
import { Caption, H3 } from './Typography';
import React, { useState } from 'react';

import {
    useUpdateMember,
    useSpringBigStore,
    useI18n,
    useTheme,
} from '@springbig/shared';
import Pressable from '~/shared/Pressable';
import { CheckBox, Button, Modal, } from '~/shared/Theme';

const WalletTerms = () => {

    const { member } = useSpringBigStore();
    const { t } = useI18n();

    const {
        highlight_text,
    } = useTheme();

    const [formData, setData] = useState<boolean>(!!member?.wallet_terms);

    const {
        mutate: updateMember,
        data: memberUpdated
    } = useUpdateMember();

    const onSubmit = (): void => {

        updateMember({
            member: {
                wallet_terms: formData
            }
        });
    };

    const handleLinkPress = (url: string): void => {

        if (!url) {
            return;
        }

        window.open(url, '_blank');
    };

    return member && (
        <Modal isOpen overflowY={'auto'}>
            <Modal.Header>
                <H3>
                    { member.merchant_name }
                </H3>
            </Modal.Header>
            <Modal.Body>
                <VStack space={4} alignItems={'center'}>
                    <Box>
                        <H3 text={'profileMenu.terms_condition'} />
                        <Caption>
                                Tap the link below to read through our updated { t('profileMenu.terms_condition') }. By
                                checking the box, you acknowledge that you have read and agree to the following terms:
                        </Caption>
                    </Box>
                    <HStack alignItems={'center'} space={2}>
                        <CheckBox
                            isChecked={formData}
                            value={formData.toString()}
                            onChange={(_formData) => {

                                setData(_formData);
                            }}
                        />
                        <VStack space={2}>
                            <Pressable onPress={() => handleLinkPress(member.terms_and_conditions_link)} flexDirection={'row'}>
                                <HStack space={1}>
                                    <Caption>I accept the </Caption>
                                    <Caption color={highlight_text}>{ t('profileMenu.terms_condition') }</Caption>
                                </HStack>
                            </Pressable>
                            { member.privacy_policy_url &&
                                <Pressable onPress={() => handleLinkPress(member.privacy_policy_url)} flexDirection={'row'}>
                                    <HStack space={1}>
                                        <Caption>& </Caption>
                                        <Caption color={highlight_text}>{ t('profileMenu.privacy_policy') }</Caption>
                                    </HStack>
                                </Pressable>
                            }
                        </VStack>
                    </HStack>
                </VStack>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    text={'Agree and Continue'}
                    mx={'auto'}
                    onPress={() => onSubmit()}
                />
            </Modal.Footer>
        </Modal>
    );
};

export default WalletTerms;
